import { type ClassValue, clsx } from "clsx";
import { getSecondsFromNow } from "shared";
import { twMerge } from "tailwind-merge";
import type { RouterOutputs } from "./trpcClient";

//* --- CSS Utils ---

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const CHART_COLOR_VARIABLES = [
  "var(--chart-1)",
  "var(--chart-2)",
  "var(--chart-3)",
  "var(--chart-4)",
  "var(--chart-5)",
];

export const lastQuarter = getSecondsFromNow("-180 days");
export const quarterDate = getSecondsFromNow("-90 days");

export function getGraphColor(index: number) {
  return CHART_COLOR_VARIABLES[index % CHART_COLOR_VARIABLES.length];
}

type Transaction = RouterOutputs["transaction"]["list"][number];
type DailySpendBreakdown = {
  [day: string]: {
    [category: string]: number;
  };
};
export function getDailySpendBreakdown(
  transactions: Transaction[],
  categorySelectFn: (t: Transaction) => string,
): DailySpendBreakdown {
  return transactions.reduce((result, t) => {
    const day = t.originatedAt.toISOString().split("T")[0];

    const existingAcc = result[day] || {};

    const category = categorySelectFn(t);
    existingAcc[category] = (existingAcc[category] || 0) + t.amountCents;

    result[day] = existingAcc;
    return result;
  }, {} as DailySpendBreakdown);
}

/*
  Turns a 2D array like
  [
    ['Header 1', 'Header 2', 'Header 3'],
    ['Value 1A', 'Value 2A', 'Value 3A'],
    ['Value 1B', 'Value 2B', 'Value 3B']
  ]
  into CSV Format
*/
export type CsvData = (string | number)[][];
export function convertToCsv(arr: CsvData) {
  return arr
    .map((row) =>
      row.map((item) => `"${item.toString().replaceAll('"', '""')}"`).join(","),
    )
    .join("\n");
}

export function downloadBlob(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function getHardcodedMerchantWebsites(merchantName?: string | null) {
  if (!merchantName) return null;

  const sanitizedMerchantName = merchantName.replaceAll(/\s\s+/g, " ");
  if (sanitizedMerchantName.startsWith("DD *DOORDASH")) return "doordash.com";
  if (
    sanitizedMerchantName.startsWith("UBER * EATS") ||
    sanitizedMerchantName.startsWith("UBER *EATS")
  )
    return "ubereats.com";

  return null;
}
